const LOCAL_API_ORIGIN = "http://127.0.0.1:5197";
const LOCAL_HOSTS = new Set(["localhost", "127.0.0.1", "::1", "[::1]"]);

// Production requests go through the website's /api and /hubs proxies.
// Use REACT_APP_API_ORIGIN only when an explicit separate API host is needed.
export const resolveApiOrigin = (hostname = "", configuredOrigin = "") => {
  const override = String(configuredOrigin).trim();
  if (override) return override.replace(/\/+$/, "");

  return LOCAL_HOSTS.has(String(hostname).toLowerCase())
    ? LOCAL_API_ORIGIN
    : "";
};

const browserHostname =
  typeof window === "undefined" ? "" : window.location.hostname;

export const API_ORIGIN = resolveApiOrigin(
  browserHostname,
  process.env.REACT_APP_API_ORIGIN
);
export const API_BASE = `${API_ORIGIN}/api`;

export const GOOGLE_CLIENT_ID =
  process.env.REACT_APP_GOOGLE_CLIENT_ID ||
  "224009896550-dmfhibo6hsf5mfm565r1gqrvuf4t6sq8.apps.googleusercontent.com";
